export default "__VITE_ASSET__D_D6tKSI__"